import { Button, Font, TextLink } from "@moneyforward/mfx_biz_react_components";

import { MainTemplate } from "@/components/templates";
import { css } from "@emotion/react";
import { PageTitle } from "@/components/molecules";
import { color } from "@/styles/theme";
import { useRouter } from "next/router";
import {
  CardRegistrationType,
  useCardRegistrationUrlV2LazyQuery,
} from "@/generated/graphql_billing";
import { useEffect, useState } from "react";
import useRollbarUtil from "../hooks/useRollbarUtil";
import config from "@/libs/config";

export const RegisterCreditCardPage = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();
  const [cardRegistrationUrl, setCardRegistrationUrl] = useState<string>();
  const { app, cardRegistrationType } = router.query;

  /**
   * graphql API 連携
   */
  const [cardRegistrationUrlQuery] = useCardRegistrationUrlV2LazyQuery({
    onCompleted: (data) => {
      if (data.cardRegistrationUrlV2) {
        setCardRegistrationUrl(data.cardRegistrationUrlV2);
      }
    },
    onError: getNotifyErrorHandlerForGraphQL(
      "Failed to get card registration url"
    ),
    context: {
      api: "billing",
    },
    variables: {
      bankName: config.BANK_SYSTEM_NAME,
      cardRegistrationType: cardRegistrationType as CardRegistrationType,
      app: app ? String(app) : "",
    },
  });

  useEffect(() => {
    if (cardRegistrationType) {
      cardRegistrationUrlQuery();
    }
  }, [router.query]);

  return (
    <div>
      <MainTemplate
        title={`${config.BANK_NICKNAME} Mikatano シリーズ クレジットカード登録`}
      >
        <div css={{ marginTop: 56 }}>
          <PageTitle mainTitle="クレジットカード情報の登録" />
        </div>
        <div css={messageboxContainerStyle}>
          <div css={messageBoxDetailStyle}>
            <Font variant="lb">【クレジットカードについて】</Font>
            <div css={{ marginTop: 8 }}>
              <Font>
                <ul css={messagesStyle}>
                  <li>
                    ・クレジットカードの名義は、個人・法人に関わらずご利用可能です。
                  </li>
                  <li>
                    ・「VISA / Master Card / JCB / Diners Club / American
                    Express」がご利用可能です。
                  </li>
                  <li>・海外発行カードはご利用できません。</li>
                </ul>
                <div css={{ marginTop: 15 }}>
                  ※カード情報の保管・管理は
                  <TextLink
                    href="https://www.gmo-pg.com/security-compliance/handling/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    GMOペイメントゲートウェイ株式会社
                  </TextLink>
                  に委託しております。
                </div>
              </Font>
            </div>
          </div>
          {cardRegistrationType === undefined && (
            <Font
              variant="s"
              css={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                color: color.attention,
                marginTop: 25,
              }}
            >
              <span>通常と異なるアクセスがありました。</span>
              <span>「戻る」操作をおこなって下さい。</span>
            </Font>
          )}
        </div>
        <div
          css={{
            display: "flex",
            justifyContent: "center",
            gap: 16,
            marginTop: 25,
          }}
        >
          {/* 戻る押下後は、遷移元ページに戻る */}
          <Button onClick={() => router.back()} variant="secondary">
            戻る
          </Button>
          <Button
            onClick={() => window.open(cardRegistrationUrl, "_self")}
            disabled={cardRegistrationType === undefined}
            variant="primary"
          >
            入力画面へ
          </Button>
        </div>
      </MainTemplate>
    </div>
  );
};

const messageboxContainerStyle = css({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const messageBoxDetailStyle = css({
  width: 640,
  padding: 16,
  background: color.gray50,
});

const messagesStyle = css({
  paddingLeft: 0,
});
